<template>
    <div class="default">
        <el-container class="default">
            <el-header style="height:70px;background-color: #fff;padding: 0;"><v-head></v-head></el-header>
            <el-container style="width:100%;height:calc(100% - 70px);">
                <el-aside width="230px"><v-leftMenu></v-leftMenu></el-aside>
                <el-container style="background:#D9D9D9;">
                    <v-tabs></v-tabs>
                    <el-main class="home-main">
                        <div class="content">
                            <router-view v-slot="{ Component }">
                                <transition name="fade-transform" mode="out-in" appear>
                                    <component :key="$route.meta.id" :is="Component"
                                    v-if="!$route.meta.keepAlive" />
                                    <keep-alive v-else>
                                        <component :is="Component" :key="$route.meta.id"
                                            v-if="$route.meta.keepAlive"></component>
                                    </keep-alive>
                                </transition>
                            </router-view>
                            <!-- <transition>
                                <keep-alive>
                                    <router-view/>
                                </keep-alive>
                            </transition> -->
                            <!-- <el-backtop target=".content"></el-backtop> -->

                        </div>
                    </el-main>
                    <el-footer class="footer"> 版权所有：© 2019-2025 浙江三生蔓迪药业有限公司 </el-footer>
                </el-container>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import vHead from './Head.vue'
import vLeftMenu from './LeftMenu.vue'
import vTabs from './Tabs.vue'
import { Base64 } from 'js-base64'
export default {
    components: {
        vHead, vLeftMenu, vTabs
    },
    computed: {
        //绑定唯一KEY，每次切换路由重新加载页面
        key() {
            let json = JSON.parse(Base64.decode(this.$route.query.data));
            return json.id;
        }
    }
}
</script>
<style scoped>
/deep/ .el-main {
    padding: 10px !important;
    margin: 10px !important;
}

.default {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
}

.home-main {
    height: calc(100% - 130px);
    background-color: #fff;
    /* background: url(../assets/background.png) no-repeat; */
}

.content {
    width: 100%;
    height: 100%;
    /* background: #FFFFFF; */
    /* border-radius: 5px; */
}

.footer {
    height: 47px;
    box-sizing: border-box;

    height: 47px;
    line-height: 46px;
    background: #FFFFFF;
    font-family: 'Abhaya Libre';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    color: #606266;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    bottom: 0;
}

/* 路由切换动画 */

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-enter-from {
    opacity: 0;
    transform: translateY(20px);
}

.fade-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

.fade-transform-enter-active,
.fade-transform-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-transform-enter-from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
}

.fade-transform-leave-to {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
}
</style>
